export function convertStringValuesToArray(values) {
  if (values) {
    values = values.replace(/'/g, '"');

    if (isArrayJson(values)) {
        values = JSON.parse(values);
    } else {
        values = values.split("|");
    }
  }

  return values;
};

export function isArrayJson(str) {
    try {
      const result = JSON.parse(str);
      return Array.isArray(result);
    } catch (e) {
      return false;
    }
  }

export function convertArrayValuesToString(values, seperatorChar, wrapChar) {
    let reducedArray = "";

    values.forEach((field, index, array) => {
      reducedArray =
        reducedArray +
        (wrapChar || "") +
        field.value.replace("'", "`") +
        (wrapChar || "") +
        (index + 1 === array.length ? "" : seperatorChar);
    });
    
    return reducedArray;
}

export function getLastTextAfterSeperator(data, seperator) {
  if (data === undefined) 
    return undefined;

  let arr = data.split(seperator);
    
  return arr[arr.length - 1];
};

String.prototype.format = String.prototype.f = function() {
  let s = this, i = arguments.length;
  while (i--) s = s.replace(new RegExp("\\{" + i + "\\}", "gm"), arguments[i]);
  return s;
};